<script lang="ts">
  import {attachPopup} from '../../PopupBox/PopupBox.svelte';
  import ImageGallery from './ImageGallery.svelte';

  function open() {
    attachPopup(null, ImageGallery, {title: 'Your Photos'});
  }
</script>

<div class="block w-full pt-4" id="image-manager">
  <div class="flex w-full items-center">
    <div class="block w-1/2 text-sm font-bold">Add Photo</div>
    <div
      class="ml-auto flex w-1/2 cursor-pointer rounded-md border bg-zinc-50 px-4 py-2 text-sm font-bold hover:bg-zinc-100"
      on:keydown={open}
      on:click={open}
    >
      <span class="block" style="font-size:14px">Upload Photos</span>
      <span class="ml-auto block">
        <i class="fa-regular fa-angle-right"></i>
      </span>
    </div>
  </div>
</div>
